export enum SearchCase {
	INSENSITIVE = 'insensitive',
}
